import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CloseIcon } from './Styles/Icons';
import { Dialog, DialogActions, DialogTitle, DialogContent, InputGroup, ButtonGroup, Button, CircularButton, FlexRow, CheckboxGroup } from './Styles/DownloadInventoryItems';

import { downloadInventoryPrices } from '../../actions/inventoryActionsV2';
import { ButtonWithLoader } from './Styles/DownloadPrices';

const DownloadPrices = ({ open, options, downloadInventoryPrices, onTrue, onFalse }) => {
	const [downloadingFile, setDownloadingFile] = useState(false);
	const [selectAll, setSelectAll] = useState(false);
	const [selectedFields, setSelectedFields] = useState([]);
	const [error, setError] = useState(null);

	const onTrueHandler = async () => {
		setDownloadingFile(true);
		let errorState = {};
		setError(errorState);

		if (selectedFields.length === 0) {
			errorState['selectedFields'] = 'No fields selected.';
		}

		if (Object.keys(errorState).length) {
			setError(errorState);
		} else {
			let fields = [];

			options.map((option) => {
				if (selectedFields.includes(option.value)) fields.push(option.value);
			});

			await downloadInventoryPrices('download-prices', { sources: fields, downloadWithData: true });
			await onTrue();
		}

		setDownloadingFile(false);
	};

	const onFalseHandler = async () => {
		await onFalse();
	};

	useEffect(() => {
		setSelectAll(false);
		setError(null);
	}, [open]);

	useEffect(() => {
		if (selectAll) {
			setSelectedFields(options.map((option) => option.value));
		} else {
			setSelectedFields([]);
		}
	}, [selectAll]);

	return (
		<Dialog
			maxWidth='sm'
			fullWidth
			open={open}
			onClose={() => (downloadingFile ? null : onFalseHandler())}
		>
			<DialogTitle>
				Download Prices
				<ButtonGroup alignRight>
					<CircularButton
						error
						outline
						disabled={downloadingFile}
						onClick={() => onFalseHandler()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent style={{ marginTop: '-30px' }}>
				<FlexRow style={{ padding: '0 1rem' }}>Select the buckets which you want to include in the data sheet.</FlexRow>

				<FlexRow style={{ padding: '0 1rem' }}>
					<InputGroup error={error && error.selectAll}>
						<CheckboxGroup
							name={'select-all'}
							disabled={false}
							value={selectAll ? ['select_all'] : []}
							onClick={(e) => {
								e.target.value.includes('select_all') ? setSelectAll(true) : setSelectAll(false);
							}}
							error={error && error.selectAll}
							options={[{ name: 'Select All', value: 'select_all', disabled: false }]}
						/>
					</InputGroup>
				</FlexRow>

				<FlexRow style={{ padding: '0 1rem' }}>
					<InputGroup
						label='Select Fields'
						markRequired={true}
						error={error && error.selectedFields}
					>
						<CheckboxGroup
							name={'selected-fields'}
							disabled={false}
							value={selectedFields}
							onClick={(e) => {
								setSelectedFields(e.target.value.split(','));
							}}
							error={error && error.selectedFields}
							options={options}
						/>
					</InputGroup>
				</FlexRow>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						primary
						outline
						disabled={downloadingFile}
						onClick={(e) => onFalseHandler()}
					>
						Cancel
					</Button>
					<ButtonWithLoader
						primary
						loading={downloadingFile}
						disabled={selectedFields.length === 0}
						onClick={(e) => onTrueHandler()}
					>
						Download
					</ButtonWithLoader>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	const bucketItems = state.inventory.bucketItems || [];
	const options = [{ name: 'Base Price', value: 'price', disabled: false }];

	bucketItems.map((bucket) => {
		options.push({ name: bucket.alias, value: bucket.id, disabled: false });
	});

	return {
		supplier: state.supplier.supplier,
		options: options,
	};
};

const mapFunctionsToProps = {
	downloadInventoryPrices,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(DownloadPrices);
